'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function useSelectionSet() {
  var deps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  // Mode = include | exclude
  var [mode, setMode] = React__namespace.useState('include');
  var [selected, setSelected] = React__namespace.useState(new Set()); // Converts the mode to `include`

  var unselectAll = React__namespace.useCallback(() => {
    setMode('include');
    setSelected(new Set());
  }, []); // Converts the mode to `exclude`

  var selectAll = React__namespace.useCallback(() => {
    setMode('exclude');
    setSelected(new Set());
  }, []);
  var toggle = React__namespace.useCallback(value => {
    var newSelected = new Set(selected);

    if (newSelected.has(value)) {
      newSelected.delete(value);
    } else {
      newSelected.add(value);
    }

    return setSelected(newSelected);
  }, [selected]);
  var selectMany = React__namespace.useCallback(values => {
    var newSelected = new Set([...selected, ...values]);
    setSelected(newSelected);
  }, [selected]);
  var unselectMany = React__namespace.useCallback(values => {
    var newSelected = new Set(selected);
    values.forEach(value => newSelected.delete(value));
    setSelected(newSelected);
  }, [selected]);
  var toggleMode = React__namespace.useCallback(() => {
    setSelected(new Set());
    setMode(mode === 'include' ? 'exclude' : 'include');
  }, [mode]); // Reset the selected set any time the key or row count changes.

  React__namespace.useEffect(() => {
    setMode('include');
    setSelected(new Set());
  }, [...deps]);
  return {
    mode,
    selected,
    toggle,
    selectAll,
    unselectAll,
    toggleMode,
    selectMany,
    unselectMany
  };
}

exports.default = useSelectionSet;
exports.useSelectionSet = useSelectionSet;
